<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-card>
        <template #header>
          <b-row>
            <b-col cols="10">
              <h3 class="text-left">Consulta de precios de tratamientos</h3>
            </b-col>
            <b-col cols="2">
              Codigo: <b> CONS_PRECIO</b>
            </b-col>
          </b-row>
        </template>
        <div class="buscarTratamiento">
          <form class="w-100" @submit.stop.prevent="obtenerTratamientos(nombreBusqueda)">
            <div class="SearchPti">
              <div class="bolderTxt hiddenDiv">
                <div><b>Nombre del tratamiento:</b></div>
              </div>
              <div class="inputBusqueda">
                <b-form-input v-model="nombreBusqueda"
                              placeholder="Ingresa un nombre"
                              type="text"
                              v-on:keypress="isLetter($event)"
                              v-b-tooltip.hover
                              title="Búsqueda por nombre completo del tratamiento"
                              v-on:keyup.enter="obtenerTratamientos(nombreBusqueda)"
                ></b-form-input>
              </div>
              <b-button variant="primary" type="submit"
              >
                <b-icon icon="search"></b-icon
                >
              </b-button>
            </div>
          </form>
        </div>
        <br/>
        <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="false"
        ></loading>
        <span>
          <b-table
              thead-tr-class="columnas"
              :items="tratamientos"
              :fields="encabezados"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              class="parrafos"
              responsive>
            <template v-slot:cell(accion)="row">
              <b-button size="sm" variant="outline-primary" @click="row.toggleDetails">
                {{ row.detailsShowing ? 'Ocultar' : 'Ver' }} Precios
              </b-button>
            </template>
            <template #row-details="row">
              <DetallePrecios :row="row"/>
            </template>
          </b-table>
          <b-pagination
              v-if="tratamientos.length > 15"
              align="center"
              v-model="paginaActual"
              :total-rows="tratamientos.length"
              :per-page="registrosPorPagina"
          ></b-pagination>
        </span>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import Header from "@/components/Header"
import miniToastr from "mini-toastr";
import DetallePrecios from "@/views/PreciosTratamientos/DetallePrecios";

export default {
  name: "PreciosTratamientos",
  components: {
    DetallePrecios,
    Header
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    nombreBusqueda: null,
    tratamientos: [],
    registrosPorPagina: 15,
    paginaActual: 1,
    loading: false,
    encabezados: [
      {key: "idTratamiento", label: "ID", sortable: true},
      {key: "nombre", label: "Nombre del Paciente", sortable: true},
      {key: "accion", label: "Acción"},
    ],
  }),
  methods: {
    obtenerTratamientos(searchTerm) {
      this.loading = true;
      this.paginaActual = 1;
      if (searchTerm != undefined && searchTerm.length > 3) {
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        const parametros = {nombre: inputTxt}
        this.$http
            .post(
                this.$api +
                "tratamientos/obtener/precios", parametros
            )
            .then((response) => {
              if (response.status === 200) {
                this.tratamientos = response.data.data
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron tratamientos");
              console.error(error);
              this.loading = false;
            })
            .finally(() => (this.loading = false));
      } else {
        this.loading = false;
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character

      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ/^\s+$/]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }

}
</script>

<style scoped>

.buscarTratamiento {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px 0 0 0;
  border: 1px solid #ddd;
  background-color: white !important;
  padding-left: 10px;
}

.SearchPti {
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.inputBusqueda {
  width: 70%;
}

</style>
